const INSERTION_FALLBACK = 'Not documented'

/**
 * 報告上的 insertion endpoint 只認 examinations.insertionLevel。
 * 這是語音 command 已驗證並落 DB 的 canonical 值，不再交給 LLM 從逐字稿猜。
 */
export function reportInsertionEndpoint(examination, insertionLevels) {
  const value = examination && examination.insertionLevel
  if (value == null || value === '') return INSERTION_FALLBACK

  const levels = Array.isArray(insertionLevels) ? insertionLevels : []
  const hit = levels.find((item) => String(item.value) === String(value))
  return hit && hit.text ? hit.text : INSERTION_FALLBACK
}

export { INSERTION_FALLBACK }
